export default {
  methods: {
    updateEcharts (arrName = 'echarts') { // 更新需要跟随一些变量变换的echarts
      for (let key of this[arrName]) {
        const request = 'request' + key
        this[request]()
      }
    },
    // 创建请求data,空去除
    createData (obj) {
      let data = {}
      for (let key in obj) {
        if (this.filter[obj[key]]) {
          data[key] = this.filter[obj[key]]
        }
      }
      return data
    }
  }
}
